import * as moment from 'moment';
import { TDrawModel } from '../../draw.model';
import { DRAW_MODEL_UTILS } from '../utils';
import { TTimelieWrapper } from './draw.tasks';
import { TDate } from '@monorepo/types';

const addTodayMarker = (drawModel: TDrawModel, background: ReturnType<typeof drawForeground>) => {
  const xPosition = DRAW_MODEL_UTILS.getPostionByDate(moment().format('YYYY-MM-DD') as TDate, drawModel);
  return background
    .selectAll('.today')
    .data([drawModel])
    .join('line')
    .classed('today', true)
    .style('stroke', '#0F31A9')
    .style('stroke-dasharray', '3, 3')
    .style('stroke-width', 3)
    .attr('x1', xPosition)
    .attr('y1', drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight + 'px')
    .attr('x2', xPosition)
    .attr('y2', 2)
    .attr('marker-end', `url(#${drawModel.defsIds.arrow})`);
};

export const drawForeground = (drawModel: TDrawModel, timelineWrapper: TTimelieWrapper) => {
  const foreground = timelineWrapper
    .selectAll('.foreground-container')
    .data([drawModel])
    .join('svg')
    .classed('foreground-container', true)
    .attr('width', drawModel.width + 'px')
    .attr(
      'height',
      drawModel.timelineModel.comptedEntities.totalEntities * drawModel.layout.entityHeight +
        drawModel.layout.headerHeight +
        'px',
    )
    .attr('transform', 'translate(' + drawModel.layout.margin.left + ',0)')
    .style('padding-top', drawModel.layout.headerHeight + 'px')
    .style('position', 'absolute')
    .style('top', drawModel.layout.headerHeight + 'px')
    .style('left', '0')
    .style('pointer-events', 'none');
  addTodayMarker(drawModel, foreground);
  return foreground;
};
